export default "__VITE_ASSET__d186ee39__"